








































import { Component, Prop, Vue } from "vue-property-decorator";
import { TweenMax, Power4 } from "gsap";

@Component
export default class About extends Vue {
  mounted() {
    TweenMax.from(document.getElementById("project__curtain"), 1, {
      y: "100vh",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
    });
    TweenMax.from(document.getElementById("project__container"), 1, {
      y: "100vh",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
      delay: 0.4,
    });
  }

  leave(el: any, done: any) {
    TweenMax.to(document.getElementById("project__container"), 0.5, {
      y: "-100vh",
      ease: Power4.easeIn,
      // onComplete: done,
    });
    TweenMax.to(document.getElementById("project__curtain"), 0.3, {
      y: "-100vh",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
      delay: 0.3,
      onComplete: done,
    });
  }
}
